<template>
  <b-card>
    <FormBuilder
      label="Kategori"
      update
      :data="$store.state.category.detailData"
      :fields="fields"
      :loading-detail="$store.state.category.loadingDetail"
      :loading-submit="$store.state.category.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('category/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('category/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('category/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
